import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@apollo/client/react';
import { Button } from '@chakra-ui/react';
import { PaywalledAction } from '@src/components/sco/PaywalledAction';
import { gql } from '@src/lib/gql';
import React, { useState } from 'react';
import { LuHeart } from 'react-icons/lu';
type BulkSaveInvestorsButtonProps = {
  isEnabled?: boolean;
  investorProfileIds?: string[];
};
export const BulkSaveInvestorsButton = props => {
  const $ = _c(12);
  const [isLoading, setIsLoading] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
    mutation ($input: BulkCreateInvestorProfileUserSaveInput!) {
      bulkCreateInvestorProfileUserSave(input: $input) {
        investorProfiles {
          id
          investorProfileId
          currentUserHasSaved
        }
      }
    }
  `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [bulkSave] = useMutation(t0);
  let t1;
  if ($[1] !== bulkSave || $[2] !== props.investorProfileIds) {
    t1 = async () => {
      if (props.investorProfileIds && props.investorProfileIds.length > 0) {
        setIsLoading(true);
        ;
        try {
          await bulkSave({
            variables: {
              input: {
                investorProfileIds: props.investorProfileIds
              }
            }
          });
        } catch (t2) {
          alert("Error: Could not add investors to favorites.");
        }
        setIsLoading(false);
      } else {
        alert("Select some investors first.");
      }
    };
    $[1] = bulkSave;
    $[2] = props.investorProfileIds;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleClick = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      variant: "outline",
      size: "sm"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = props.investorProfileIds?.length == 0;
  const t4 = props.investorProfileIds?.length > 0 ? "cta" : "outline";
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <LuHeart />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = props.investorProfileIds?.length || null;
  let t7;
  if ($[6] !== handleClick || $[7] !== isLoading || $[8] !== t3 || $[9] !== t4 || $[10] !== t6) {
    t7 = <PaywalledAction contentPermission="canAccessFGInvestorContacts" upgradeCtaButtonProps={t2}><Button disabled={t3} loading={isLoading} size="sm" variant={t4} onClick={handleClick}>{t5}{"Save "}{t6}Selected</Button></PaywalledAction>;
    $[6] = handleClick;
    $[7] = isLoading;
    $[8] = t3;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};